<template>
  <v-container>
    <toolbar mode="export" title="Generate" view="list" />
    <v-card flat>
      <ExportForm 
        :predictions="predictions" 
        :connections="connections" 
        :techniques="techniques"
        @submitted="onSubmit">
      </ExportForm>
    </v-card>
  </v-container>
</template>
<script>
import ExportForm from "@/components/Forms/Export"
import Exports from "@/api/exports"
import Connections from "@/api/connections"
import Predictions from "@/api/predictions"
import Techniques from "@/api/techniques"
import toolbar from "@/components/toolbar"
export default {
  name: "ExportCreate",
  components: {
    toolbar,
    ExportForm,
  },
  data() {
    return {
      predictions: [],
      techniques: [],
      connections: [],
    }
  },
  mounted() {
    Predictions.list().then(response => this.predictions = response.data.results)
    Connections.list().then(response => this.connections = response.data)
    Techniques.list().then(response => this.techniques = response.data )
  },
  methods: {
    onSubmit(data) {
      let payload = {
        prediction: data.prediction,
        config: data.config,
        owner: this.user.id
      }
      Exports.create(payload).then(_ => {
        this.notify('Generating export')
        this.$router.push({ name: 'exportList' })
      })
    }
  }
}
</script>